import React, { Component } from "react";
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  warning,
  warningNotification,
  success,
  successNotification,
  error,
  errorNotification,
} from "../notification/notifications";
// import { withRouter } from "react-router-dom";
import { VideoService } from "../../services/video.service";
import { LoginService } from "../../services/login.service";
export default class addVideo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      listOfHours: [],
      listOfMins: [],
      listOfSecs: [],
      allCategories: [],
      allSubCategories: [],
      isSaveBtnDisabled: false,
    };
  }
  handleCancel = () => {
    this.props.history.goBack("-1");
  };
  initailizedTimeDetails = () => {
    var listOfHours = [];
    var listOfMins = [];
    var listOfSecs = [];

    for (var i = 0; i < 24; i++) {
      listOfHours.push(i);
    }
    for (var j = 0; j < 60; j++) {
      listOfMins.push(j);
      listOfSecs.push(j);
    }

    this.setState({ listOfHours: listOfHours });
    this.setState({ listOfMins: listOfMins });
    this.setState({ listOfSecs: listOfSecs });
  };
  GetAllCategoryByLevel = (level, fn) => {
    this.setState({ loading: true });
    let data = {};
    LoginService.TokenUser((res) => {
      if (res.status === "success") {
        VideoService.fetchAllCategoryByLevel(`level=${level}`, data, (res1) => {
          console.log("res", res1);

          fn(res1.responseListObject);
          this.setState({ loading: false });
        });
      } else if (res.status === "fail") {
        this.setState({ loading: false });
        if (res.reasonCode === "SM_11") {
          window.location.href = "/";
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false });
          error(res.reasonText, errorNotification);
        }
      }
    });
  };

  componentDidMount() {
    this.initailizedTimeDetails();
    this.GetAllCategoryByLevel(0, (items) =>
      this.setState({
        allCategories: items ? items : [],
      })
    );
    // this.GetAllCategoryByLevel(1, (items) =>
    //   this.setState({
    //     allSubCategories: items ? items : [],
    //   })
    // );
  }
  selectCategory(value, setFieldValue) {
    const data = {
      filteredCategory: [value],
    };
    if (value) {
      VideoService.fetchAllCategoryByLevel(`level=1`, data, (res1) => {
        setFieldValue("allSubCategories", res1.responseListObject);
        setFieldValue("subCategory", "");
      });
    } else {
      setFieldValue("allSubCategories", []);
      setFieldValue("subCategory", "");
    }
  }
  handlePriceChange = (e,setFieldValue) => {
    e.preventDefault();
    const input = e.target.value.replace(/[^\d.]/g, ''); // Remove non-digit characters
    setFieldValue("price",input.slice(0, 10))
  }
  render() {
    return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          videoName: "",
          videoDescription: "",
          category: "",
          categoryLevel: "",
          isFree: "",
          price: "",
          gcubeId: "",
          videoUrl: "",
          document: [],
          hours: "",
          minutes: "",
          seconds: "",
          subCategory: "",
          // allSubCategories:this.state.allSubCategories,
          allSubCategories: [],
          listOfHours: this.state.listOfHours,
          listOfMins: this.state.listOfMins,
          listOfSecs: this.state.listOfSecs,
          videoURL: "",
          documentTypeCheckForVideo: false,
          documentSizeCheckForVideoCheck: false,
          topFree:"N",
          mostPopular:"",
        }}
        validationSchema={Yup.object().shape({
          videoName: Yup.string()
            .required("You must specify a Video Name")
            .max(50, " Video Name should not  be greater than 50 characters"),
          videoDescription: Yup.string().max(
            200,
            "Description should not be greater then 200 characters"
          ),
          category: Yup.string().required("You must specify a Category"),
          // subCategory: Yup.string().required("You must specify a sub category"),
          isFree: Yup.string().when("topFree",{
            is: (topFree) => (topFree === "N" ? true : false),
            
          then:Yup.string().required("You must specify Is Free"),
          otherwise: Yup.string(),
        }),
          price: Yup.string().when("isFree", {
            is: (isFree) => (isFree === "N" ? true : false),
            then: Yup.string()
              .required("Price is required")
              // .max(10, "Price not greater than 10")
              .matches(
                /^([1-9]\d*|0{1})([1-9]\d*|0)(\.\d{0,2})?$/,
                "Please provide valid price Value more than one number and 2 decimals values only"
              ),
            otherwise: Yup.string(),
          }),
          gcubeId: Yup.string()
            .max(10, "G Cube ID should not be greater then 10 characters")
            .matches(
              /^([0-9]\d*)?$/,
              // /^([1-9]\d*|0{1})([1-9]\d*|0)(\.\d+)?$/,
              "Please provide valid Gcube ID"
            ),
          hours: Yup.string().required("You must specify a hours"),
          minutes: Yup.string().required("You must specify a minutes"),
          seconds: Yup.string().required("You must specify a seconds"),
          videoUrl: Yup.string()
            .max(1000, "URL should not be greater then 1000 characters")
            .required("You must specify a Video URL"),
        })}
        onSubmit={(fields) => {
          let formattedTime = "";

          if (
            (fields["seconds"] !== undefined && fields["seconds"] !== "") ||
            (fields["minutes"] !== undefined && fields["minutes"] !== "") ||
            (fields["hours"] !== undefined && fields["hours"] !== "")
          ) {
            let hours =
              fields["hours"].length === 1
                ? "0" + fields["hours"]
                : fields["hours"];
            let minutes =
              fields["minutes"].length === 1
                ? "0" + fields["minutes"]
                : fields["minutes"];
            let seconds =
              fields["seconds"].length === 1
                ? "0" + fields["seconds"]
                : fields["seconds"];
            formattedTime = hours + ":" + minutes + ":" + seconds;
          } else {
            formattedTime = "";
          }

          let data = {
            isActive: 1,
            videoName: fields.videoName ? fields.videoName : "",
            videoDesc: fields.videoDescription ? fields.videoDescription : "",
            categoryID:
              fields.subCategory && !Array.isArray(fields.subCategory)
                ? fields.subCategory
                : fields.category,
            categoryLevel: fields.categoryLevel,
            // categoryLevel:
            //   fields.subCategory && !Array.isArray(fields.subCategory)
            //     ? fields.level
            //     : 0,
            isFree: fields.topFree==="Y"?"Y":fields.isFree ? fields.isFree : "",
            // price: fields.isFree === "Y" ? 0 : fields.price.toFixed(2),
            price: fields.isFree === "Y" ? 0 : fields.price,
            videoUrl: fields.videoUrl ? fields.videoUrl : "",
            duration: formattedTime,
            gcubeID:
              fields.gcubeId === 0 ? 0 : fields.gcubeId ? fields.gcubeId : null,
            topFree: fields.topFree ? fields.topFree : null,
            mostPopular: fields.mostPopular ? fields.mostPopular : null,
          };
          this.setState({ loading: true, isSaveBtnDisabled: true })
          VideoService.saveVideo(
            data,
            (cb) => {
              console.log("cb", cb);
              // console.log("cb.status", cb.status);
              if (cb.status === "success") {
                this.setState({ loading: false });
                success("Video added successfully!", successNotification);
                this.props.history.push("/ops-video-list");
              } else {
                // console.log("cb.status", cb.status);
                warning(cb.reasonText, {
                  ...warningNotification,
                  container: "top-center",
                });
                this.setState({ loading: false,isSaveBtnDisabled: false });
              }
            },
            (err) => console.log("Error", err)
          );
        }}
        render={({
          values,
          errors,
          touched,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          ...formikProps
        }) => (
          <>
            {this.state.loading && (
              <PopUpPortal
                HidePopup={this.state.loading}
                IsVisible={this.state.loading}
              />
            )}
            <section className="dashboard-tab user-profile pt-50 mb-50">
              {/* <div>
                <pre>{JSON.stringify(values,null,2)}</pre>
              </div> */}
              <Form onSubmit={handleSubmit} className="form-group">
                <div className="">
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pt-130">
                        <div className="bg-box">
                          <section className="create-user" id="create-user">
                            <div className="row">
                              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                <h2 className="sub-header">Add Video</h2>
                                <div className="form-group">
                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Video Name{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <Field
                                        type="text"
                                        name="videoName"
                                        id="videoName"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.videoName}
                                        title={values.videoName}
                                        placeholder="Video Name"
                                        className={
                                          "form-control" +
                                          (errors.videoName && touched.videoName
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      <ErrorMessage
                                        name="videoName"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Video Description </label>
                                      <Field
                                        type="text"
                                        name="videoDescription"
                                        id="videoDescription"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        title={values.videoDescription}
                                        value={values.videoDescription}
                                        placeholder="Video Description"
                                        className={
                                          "form-control" +
                                          (errors.videoDescription &&
                                          touched.videoDescription
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      <ErrorMessage
                                        name="videoDescription"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Category{" "}
                                        <span className="validation"> *</span>
                                      </label>

                                      <Field
                                        as="select"
                                        name="category"
                                        id="category"
                                        // onChange={(event) => {
                                        //   handleChange(event);
                                        //   this.selectCategory(
                                        //     event.target.value,setFieldValue
                                        //   );
                                        // }}
                                        onChange={(event) => {
                                          var level = 0;
                                          for (var option of event.target
                                            .options) {
                                            if (option.selected) {
                                              setFieldValue(
                                                (values.categoryLevel = 0)
                                              );
                                              setFieldValue(
                                                (values.category = option.value)
                                              );
                                              this.selectCategory(
                                                event.target.value,
                                                setFieldValue
                                              );
                                            }
                                          }
                                        }}
                                        value={values.category}
                                        title={values.category}
                                        className={
                                          "form-control" +
                                          (errors.category && touched.category
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option value={""}>-- Select --</option>
                                        {this.state.allCategories.map(
                                          (data) => (
                                            <option value={data.categoryID}>
                                              {data.categoryName}
                                            </option>
                                          )
                                        )}
                                      </Field>
                                      <ErrorMessage
                                        name="category"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Sub Category </label>

                                      <Field
                                        as="select"
                                        name="subCategory"
                                        id="subCategory"
                                        onChange={(event) => {
                                          var level = 0;
                                          for (var option of event.target
                                            .options) {
                                            if (option.selected) {
                                              level = option.getAttribute(
                                                "data-level"
                                              );
                                              setFieldValue(
                                                (values.categoryLevel = level)
                                              );
                                              setFieldValue(
                                                (values.subCategory =
                                                  option.value)
                                              );
                                            }
                                          }
                                        }}
                                        value={values.subCategory}
                                        title={values.subCategory}
                                        className={
                                          "form-control" +
                                          (errors.subCategory &&
                                          touched.subCategory
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <>
                                          <option value={""}>
                                            -- Select --
                                          </option>
                                          {values.allSubCategories.map(
                                            (data) => (
                                              <option
                                                value={data.categoryID}
                                                data-level={data.categoryLevel}
                                              >
                                                {data.categoryName}
                                              </option>
                                            )
                                          )}
                                        </>
                                      </Field>
                                      <ErrorMessage
                                        name="subCategory"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>Gcube ID </label>
                                      <Field
                                        type="number"
                                        name="gcubeId"
                                        id="gcubeId"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        title={values.gcubeId}
                                        value={values.gcubeId}
                                        placeholder="Gcube ID"
                                        className={
                                          "form-control" +
                                          (errors.gcubeId && touched.gcubeId
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      <ErrorMessage
                                        name="gcubeId"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Duration{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                          <Field
                                            as="select"
                                            name="hours"
                                            id="hours"
                                            onChange={(e) => {
                                              setFieldValue(
                                                (values.hours = e.target.value)
                                              );
                                            }}
                                            className={
                                              "form-control " +
                                              (errors.hours && touched.hours
                                                ? "is-invalid"
                                                : "")
                                            }
                                            // className="form-control"
                                          >
                                            <option value="">HH</option>
                                            {(values.listOfHours || []).map(
                                              (h, index) => (
                                                <option key={index} value={h}>
                                                  {" "}
                                                  {h}{" "}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                          <ErrorMessage
                                            name="hours"
                                            className="validation "
                                            component="div"
                                          />
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                          <Field
                                            as="select"
                                            name="minutes"
                                            id="minutes"
                                            onChange={(e) => {
                                              setFieldValue(
                                                (values.minutes =
                                                  e.target.value)
                                              );
                                            }}
                                            className={
                                              "form-control " +
                                              (errors.minutes && touched.minutes
                                                ? "is-invalid"
                                                : "")
                                            }
                                            // className="form-control"
                                          >
                                            <option value="">MM</option>
                                            {(values.listOfMins || []).map(
                                              (m, index) => (
                                                <option key={index} value={m}>
                                                  {" "}
                                                  {m}{" "}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                          <ErrorMessage
                                            name="minutes"
                                            className="validation "
                                            component="div"
                                          />
                                        </div>
                                        <div className="col-md-4 col-lg-4 col-sm-4 col-xs-4 pl pr">
                                          <Field
                                            as="select"
                                            name="seconds"
                                            id="seconds"
                                            onChange={(e) => {
                                              setFieldValue(
                                                (values.seconds =
                                                  e.target.value)
                                              );
                                            }}
                                            className={
                                              "form-control " +
                                              (errors.seconds && touched.seconds
                                                ? "is-invalid"
                                                : "")
                                            }
                                            // className="form-control"
                                          >
                                            <option value="">SS</option>
                                            {(this.state.listOfSecs || []).map(
                                              (s, index) => (
                                                <option key={index} value={s}>
                                                  {" "}
                                                  {s}{" "}
                                                </option>
                                              )
                                            )}
                                          </Field>
                                          <ErrorMessage
                                            name="seconds"
                                            className="validation "
                                            component="div"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">
                                  <div class="col-md-4 col-sm-6 col-xs-12">
                                        {/* <div>
                                        <label>
                                          Top Free{" "}
                                          <span className="validation"> *</span>
                                        </label>
                                        </div> */}
                                        <Field
                                          type="checkbox"
                                          name="topFree"
                                          onChange={()=>{
                                            if(values.topFree==='N'){
                                              setFieldValue("topFree",'Y')
                                              setFieldValue("isFree","Y")
                                            }
                                            else{
                                              setFieldValue("topFree","N")
                                            }
                                          }}
                                          checked={values.topFree==='Y'}
                                          
                                        />
                                        <label
                                          className="form-field"
                                          htmlFor="topFree"
                                        >
                                          <span>&nbsp;Top Free</span>
                                          {/* <input
                                                  name="topFree"
                                                  type="checkbox"
                                                  onChange={handleChange}
                                                /> */}
                                        </label>
                                        <div className="form-field-error">
                                          {errors.topFree}
                                        </div>
                                      </div>
                                      <div class="col-md-4 col-sm-6 col-xs-12">
                                        <Field
                                          type="checkbox"
                                          name="mostPopular"
                                          onChange={()=>{
                                            if(["",null].includes(values.mostPopular)){
                                              setFieldValue("mostPopular","Y")
                                            }
                                            else{
                                              setFieldValue("mostPopular",null)
                                            }
                                          }}
                                          checked={values.mostPopular==="Y"}
                                        />
                                        <label
                                          className="form-field"
                                          htmlFor="mostPopular"
                                        >
                                          <span>&nbsp;Most Popular</span>
                                        </label>
                                      </div>

                                  </div>

                                  <div className="row">
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Video URL{" "}
                                        <span className="validation"> *</span>
                                      </label>
                                      <textarea
                                        type="text"
                                        name="videoUrl"
                                        id="videoUrl"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.videoUrl}
                                        title={values.videoUrl}
                                        placeholder="Video Name"
                                        className={
                                          "form-control" +
                                          (errors.videoUrl && touched.videoUrl
                                            ? " is-invalid"
                                            : "")
                                        }
                                      />
                                      <ErrorMessage
                                        name="videoUrl"
                                        className="validation"
                                        component="div"
                                      />
                                    </div>
                                    {values.topFree!=="Y"&&
                                    <div className="col-md-4 col-sm-6 col-xs-12">
                                      <label>
                                        Is Free{" "}
                                        <span className="validation"> *</span>
                                      </label>

                                      <Field
                                        as="select"
                                        name="isFree"
                                        id="isFree"
                                        onChange={handleChange}
                                        value={values.isFree}
                                        title={values.isFree}
                                        className={
                                          "form-control" +
                                          (errors.isFree && touched.isFree
                                            ? " is-invalid"
                                            : "")
                                        }
                                      >
                                        <option>-- Select --</option>
                                        <option value="N">No</option>
                                        <option value="Y">Yes</option>
                                      </Field>
                                      <ErrorMessage
                                        name="isFree"
                                        className="validation "
                                        component="div"
                                      />
                                    </div>
        }

                                    {values.isFree === "N" ? (
                                      <div className="col-md-4 col-sm-6 col-xs-12">
                                        <label>Price </label>
                                        <span className="validation"> *</span>
                                        <Field
                                          type="text"
                                          maxLength={10}
                                          name="price"
                                          id="price"
                                          onChange={(e)=>{handleChange(e);
                                            this.handlePriceChange(e,setFieldValue);
                                          }}
                                          onBlur={handleBlur}
                                          title={values.price}
                                          value={values.price}
                                          placeholder="Price"
                                          className={
                                            "form-control" +
                                            (errors.price && touched.price
                                              ? " is-invalid"
                                              : "")
                                          }
                                        />
                                        <ErrorMessage
                                          name="price"
                                          className="validation "
                                          component="div"
                                        />
                                      </div>
                                    ) : (
                                      ((values.price = ""),
                                      (touched.price = ""))
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </section>

                          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-20">
                            <button
                              name="cancelForm"
                              type="button"
                              className="btn-4 pull-right"
                              onClick={this.handleCancel}
                            >
                              Cancel
                            </button>

                            <button
                              name="Save"
                              type="submit"
                              className="btn-4 mr-20 pull-right"
                              disabled={this.state.isSaveBtnDisabled}
                              style={{
                                opacity: this.state.isSaveBtnDisabled ? 0.5 : 1 ,
                                cursor: this.state.isSaveBtnDisabled ? "not-allowed" : "pointer" 
                              }}
                            >
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </section>
          </>
        )}
      />
    );
  }
}
